module.exports = __webpack_public_path__ + "static/img/admin_index.388d338.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/logo/admin_index.png
// module id = DA+h
// module chunks = 1